import React from 'react'

export function LogoCDSmallIcon({ className }: { className?: string }) {
	return (
		<svg
			width='31'
			height='36'
			viewBox='0 0 31 36'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M1.00864 22.684C0.753389 22.5595 0.647391 22.2517 0.771884 21.9964L3.62713 16.1423C3.75163 15.887 4.05947 15.781 4.31472 15.9055L29.5799 28.2282C29.8351 28.3527 29.9411 28.6605 29.8166 28.9158C28.8649 30.8672 27.9131 32.8185 26.9614 34.7699C26.8369 35.0252 26.5291 35.1311 26.2738 35.0067L1.00864 22.684Z'
				fill='white'
			/>
			<path
				d='M1.55714 7.77203C1.30189 7.64753 1.19589 7.33969 1.32039 7.08444L4.17563 1.23032C4.30013 0.975069 4.60797 0.869071 4.86322 0.993564L30.1284 13.3162C30.3836 13.4407 30.4896 13.7486 30.3651 14.0038C29.4134 15.9552 28.4617 17.9065 27.5099 19.8579C27.3854 20.1132 27.0776 20.2192 26.8223 20.0947L1.55714 7.77203Z'
				fill='white'
			/>
		</svg>
	)
}
export function LogoPOSmallIcon({ className }: { className?: string }) {
	return (
		<svg
			width='33'
			height='34'
			viewBox='0 0 33 34'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M25.2391 16.1918C25.2634 16.4581 25.2759 16.7277 25.2759 17.0001C25.2759 21.8421 21.3429 25.8134 16.4345 25.8134C11.5261 25.8134 7.59308 21.8421 7.59308 17.0001C7.59308 12.1581 11.5261 8.18675 16.4345 8.18675C16.7103 8.18675 16.983 8.19929 17.2521 8.22381L17.9164 0.783307C17.4283 0.739286 16.934 0.716797 16.4345 0.716797C7.44035 0.716797 0.14917 8.00707 0.14917 17.0001C0.14917 25.9931 7.44035 33.2834 16.4345 33.2834C25.4286 33.2834 32.7198 25.9931 32.7198 17.0001C32.7198 16.5156 32.6986 16.036 32.6572 15.5622L25.2391 16.1918Z'
				fill='white'
			/>
			<path
				d='M20.7524 9.30663C22.2168 10.1253 23.421 11.3472 24.2177 12.8177L30.7972 9.31853C29.3309 6.58316 27.1058 4.31528 24.4032 2.79618L20.7524 9.30663Z'
				fill='white'
			/>
		</svg>
	)
}
export function LogoWSSmallIcon({ className }: { className?: string }) {
	return (
		<svg
			width='34'
			height='34'
			viewBox='0 0 34 34'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M25.7058 18.2128C25.1797 21.9968 22.2044 25.1397 18.2171 25.7201C13.3803 26.4242 8.886 23.0909 8.17884 18.2751C7.60651 14.3774 9.69026 10.7032 13.0698 9.07051L9.71997 2.38585C3.51929 5.4196 -0.296313 12.1828 0.756923 19.3555C2.06337 28.2526 10.3664 34.4106 19.3022 33.1098C26.6992 32.0331 32.211 26.1829 33.1491 19.1533L25.7058 18.2128Z'
				fill='white'
			/>
			<path
				d='M16.9729 8.18611C20.9125 8.19736 24.3987 10.8302 25.4604 14.6227L32.7137 12.7157C30.7788 5.61643 24.2549 0.689065 16.8949 0.716914L16.9729 8.18611Z'
				fill='white'
			/>
		</svg>
	)
}
